// Lib
import React from 'react';

// Components
import ElementTool from './ElementTool';
import RequireElementTypeEditPermission from './RequireElementTypeEditPermission';
import Icon from '../../../../components/icons/Icon';

// Utils
import randomString from '../../../../../common/uid/randomString';

// Constants
import { HEADER_CARD_DISPLAY_NAME } from '../../../../../common/cards/cardConstants';

import { ElementToolSettings, ToolbarItemConfig } from '../../toolbarTypes';
import { ImMNCurrentUser } from '../../../../user/currentUserSelector';

const getHeaderDefaultContent = () => ({
    textContent: {
        type: 'doc',
        content: [
            {
                type: 'heading',
                attrs: {
                    key: randomString(5),
                    textAlign: 'center',
                    level: 1,
                },
            },
        ],
    },
    background: null,
    transparent: {
        enabled: true,
    },
});

type HeaderToolProps = {
    toolName: string;
    currentUser: ImMNCurrentUser;
    currentBoardId: string;
    item: ToolbarItemConfig;
    elementTypeObject: any;
    gridSize: number;
    selectOnCreate: boolean;
    editOnCreate: boolean;
    currentUserId: string;
    permissions: number;
    suggestedColors: string[];
};

const HeaderTool = (props: HeaderToolProps) => {
    const { toolName, item, currentBoardId, gridSize, selectOnCreate, editOnCreate, currentUserId, permissions } =
        props;

    const toolSettings = item?.toolSettings as ElementToolSettings | undefined;
    const elementTypeObject = toolSettings?.elementTypeObject || props.elementTypeObject || {};

    return (
        <RequireElementTypeEditPermission elementType={elementTypeObject.elementType} permissions={permissions}>
            <ElementTool
                name={HEADER_CARD_DISPLAY_NAME}
                toolName={toolName}
                elementType={elementTypeObject.elementType}
                currentBoardId={currentBoardId}
                currentUserId={currentUserId}
                gridSize={gridSize}
                editOnCreate={editOnCreate}
                selectOnCreate={selectOnCreate}
                icon={<Icon name="element-header" gridSize={gridSize} />}
                getDefaultContent={getHeaderDefaultContent}
            />
        </RequireElementTypeEditPermission>
    );
};

export default HeaderTool;
